"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ProductCardFooter = void 0;
require("./ProductCardFooter.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ProductCardFooter component
 *
 * @method
 * @param { ProductCardFooterProps} props
 * @returns ProductCardFooter
 */

const ProductCardFooter = props => {
  const {
    alignment,
    externalFooterActionElement,
    sponsoredBadgeLabel
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-ProductCardFooter', {
    [`pal-c-ProductCardFooter--${alignment}`]: alignment,
    'pal-c-ProductCardFooter__flexAlignment': sponsoredBadgeLabel,
    'pal-c-ProductCardFooter__extraMargin': !sponsoredBadgeLabel
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalFooterActionElement && (0, _renderObject.renderObject)(externalFooterActionElement), sponsoredBadgeLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardFooter__sponsored"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    message: sponsoredBadgeLabel,
    style: "transparent",
    variant: "default"
  })));
};

/**
 * Property type definitions
 * @typedef ProductCardFooterProps
 * @type {object}
 * @property {object} addToBagAction - add to bag action (palette action)
 * @property {string} alignment - Where the text content should align horizontally
 * @property {object} externalFooterActionElement - external footer action (from web-site)
 * @property {string} sponsoredBadgeLabel - sponsored badge label text
 */
exports.ProductCardFooter = ProductCardFooter;
const propTypes = exports.propTypes = {
  /**
   * Sets the actions (palette only, no business logic)
   */
  addToBagAction: _propTypes.default.object,
  /**
   * Where the text content should align horizontally
   * - **left:** left side of available space
   * - **center:** center of available space
   * - **right:** right of available space
   * - **between:** space between actions
   * - **around:** equal space around actions
   */
  alignment: _propTypes.default.oneOf(['left', 'right', 'center', 'between', 'around']),
  /**
   * Sets the external footer action (from web-site)
   *  <Button
   *    label={ addToBagAction.label }
   *    onClick={ addToBagAction.action }
   *    size='tiny'
   *    screenReaderText={ addToBagAction.screenReaderText }
   *    width={ addToBagAction.width }
   *    variant='primary'
   *  />
   */
  externalFooterActionElement: _propTypes.default.object,
  /**
   * Sets the sponsored badge label text
   */
  sponsoredBadgeLabel: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} align='left' - sets the default for align
 */
const defaultProps = exports.defaultProps = {
  alignment: 'left'
};
ProductCardFooter.propTypes = propTypes;
ProductCardFooter.defaultProps = defaultProps;
var _default = exports.default = ProductCardFooter;